import Vue from 'vue';
import './plugins/bootstrap-vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vSelect from 'vue-select';
import VueSweetalert2 from 'vue-sweetalert2';
import VueGoodTablePlugin from 'vue-good-table';
import VueApexCharts from 'vue-apexcharts';
import VueNumeric from 'vue-numeric';
import DatePicker from 'vue2-datepicker';
import InputTag from 'vue-input-tag';
import { MonthPicker } from 'vue-month-picker';
import { MonthPickerInput } from 'vue-month-picker';
// import DropZone from 'dropzone-vue';
// import VueCurrencyInput from 'vue-weblineindia-currency-input';

import 'vue-select/dist/vue-select.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-good-table/dist/vue-good-table.css';
// import 'dropzone-vue/dist/dropzone-vue.common.css';
// dashkit themes
import './assets/css/libs.bundle.css';
import './assets/css/theme.bundle.css';
import 'vue2-datepicker/index.css';
// import 'vue2-datepicker/locale/zh-cn';
// import QrcodeVue from "qrcode.vue";

import VeeValidate from 'vee-validate';
import VueEditor from 'vue2-editor';
import Multiselect from "vue-multiselect";
// import Calendar from "v-calendar/lib/components/calendar.umd";
// import DatePicker from "v-calendar/lib/components/date-picker.umd";

window.queryString = require('query-string');

Vue.use(VueSweetalert2);
Vue.use(VueGoodTablePlugin);
// Vue.use(DropZone)
Vue.use(VueApexCharts);
Vue.use(VeeValidate);
Vue.use(VueNumeric);
Vue.use(DatePicker);
Vue.use(MonthPicker);
Vue.use(MonthPickerInput);
Vue.use(VueEditor);
// Vue.use(VueCurrencyInput)
// Vue.component("v-calendar", Calendar);
// Vue.component("v-date-picker", DatePicker);

Vue.component('v-select', vSelect);
Vue.component('v-checkbox', vSelect);
Vue.component('apexchart', VueApexCharts);
Vue.component('input-tag', InputTag);
// Vue.component("qrcode-vue", QrcodeVue);
Vue.component('multiselect', Multiselect)

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: function (h) {
		return h(App);
	},
}).$mount('#app');
